import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';

import { FacilityService } from '../../_services/facility.service'

@Component({
    selector: 'app-edit-particulars-dialog',
    templateUrl: './edit-particulars.component.html',
    styleUrls: ['./edit-particulars.component.less']
})
export class EditParticularsDialogComponent implements OnInit {

    private busy: boolean;
    private id: number;
    private title: string;
    private unit: string;
    private particularsToDate: number;

    constructor(public dialogRef: MatDialogRef<EditParticularsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private snackBar: MatSnackBar,
        private facilityService: FacilityService) {
        this.id = data.facility.Id;
        this.title = data.facility.Title;
        this.unit = data.facility.Unit;
        this.particularsToDate = data.facility.ParticularsToDate;
    }

    ngOnInit() {
        this.busy = false;
    }

    edit(form) {
        console.log(this);
        this.busy = true;
        this.dialogRef.disableClose = true;

        this.facilityService.editFacility({
            Id: this.id,
            Title: this.title,
            Unit: this.unit,
            ParticularsToDate:
            this.particularsToDate
        }).subscribe(response => {
                let result = response.json().Result;

                this.dialogRef.close({ Facility: result.Facility });

                this.snackBar.open('Facility was updated successfully.', null, { duration: 2000 });
            },
            errorResponse => {
                let error = errorResponse.Message;//.json();

                this.snackBar.open('Failed to update facility.', null, { duration: 2000 });
                this.busy = false;
            });
    }
}



// WEBPACK FOOTER //
// ./Angular/app/projects/edit-particulars/edit-particulars.component.ts